import styled from 'styled-components';

export const MarginSmallTb = styled("div")`
    margin: ${props => props.theme.spacing.small} 0;
`;

export const MarginSmallLr = styled("div")`
    margin: 0 ${props => props.theme.spacing.small};
`;

export const MarginSmall = styled("div")`
    margin: ${props => props.theme.spacing.small};
`;

export const MarginMediumTb = styled("div")`
    margin: ${props => props.theme.spacing.medium} 0;
`;

export const MarginMediumLr = styled("div")`
    margin: 0 ${props => props.theme.spacing.medium};
`;

export const MarginMedium = styled("div")`
    margin: ${props => props.theme.spacing.medium};
`;

export const MarginLargeTb = styled("div")`
    margin: ${props => props.theme.spacing.large} 0;
`;

export const MarginLargeLr = styled("div")`
    margin: 0 ${props => props.theme.spacing.large};
`;

export const MarginLarge = styled("div")`
    margin: ${props => props.theme.spacing.large};
`;

export const MarginHugeTb = styled("div")`
    margin: ${props => props.theme.spacing.largex} 0;
`;

export const MarginHugeLr = styled("div")`
    margin: 0 ${props => props.theme.spacing.largex};
`;

export const MarginHuge = styled("div")`
    margin: ${props => props.theme.spacing.largex};
`;

export const PaddingSmallTb = styled("div")`
    padding: ${props => props.theme.spacing.small} 0;
`;

export const PaddingSmallLr = styled("div")`
    padding: 0 ${props => props.theme.spacing.small};
`;

export const PaddingSmall = styled("div")`
    padding: ${props => props.theme.spacing.small};
`;

export const PaddingMediumTb = styled("div")`
    padding: ${props => props.theme.spacing.medium} 0;
`;

export const PaddingMediumLr = styled("div")`
    padding: 0 ${props => props.theme.spacing.medium};
`;

export const PaddingMedium = styled("div")`
    padding: ${props => props.theme.spacing.medium};
`;

export const PaddingLargeTb = styled("div")`
    padding: ${props => props.theme.spacing.large} 0;
`;

export const PaddingLargeLr = styled("div")`
    padding: 0 ${props => props.theme.spacing.large};
`;

export const PaddingLarge = styled("div")`
    padding: ${props => props.theme.spacing.large};
`;

export const PaddingHugeTb = styled("div")`
    padding: ${props => props.theme.spacing.largex} 0;
`;

export const PaddingHugeLr = styled("div")`
    padding: 0 ${props => props.theme.spacing.largex};
`;

export const PaddingHuge = styled("div")`
    padding: ${props => props.theme.spacing.largex};
`;